import { render } from "./giftDetailDialog.vue?vue&type=template&id=e3e06a3a&scoped=true"
import script from "./giftDetailDialog.vue?vue&type=script&lang=js"
export * from "./giftDetailDialog.vue?vue&type=script&lang=js"

import "./giftDetailDialog.vue?vue&type=style&index=0&id=e3e06a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3e06a3a"]])

export default __exports__